export default "__VITE_ASSET__86ec8567__"